import { notification } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import apiNetCore from '../../../../../services/apiNetCore';
import { Spin } from '../../../../../styles/global';
import {
  Container,
  LoadingContainer,
  NoDataContainer,
  Table,
  TableHeaderRow,
  TableRow,
} from './styles';

const LotesTable = ({ idLotes }) => {
  const [lotes, setLotes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const onInit = async () => {
      setLoading(true);

      try {
        const { data } = await apiNetCore.post(
          'demanda/obter-aderencia-lotes',
          {
            idLotes,
          }
        );

        setLotes(data);
      } catch (e) {
        notification.error({ message: 'Falha ao obter dados de aderência.' });
      }

      setLoading(false);
    };

    onInit();
  }, [idLotes]);

  return (
    <Container>
      <h2>Lotes</h2>
      {lotes?.length !== 0 ? (
        <Table>
          <TableHeaderRow>
            <th>Id lote</th>
            <th>Carregado por</th>
            <th>% de aderência do dia</th>
          </TableHeaderRow>
          {lotes.map(lote => (
            <TableRow>
              <td>{lote.idLote}</td>
              <td>{lote.nomeTransportadora}</td>
              <td>{Math.round(lote.percentualAderencia)}%</td>
            </TableRow>
          ))}
        </Table>
      ) : (
        <NoDataContainer>
          {!loading && <h3>Não há dados de lotes disponíveis</h3>}
        </NoDataContainer>
      )}
      {loading && (
        <LoadingContainer>
          <Spin />
        </LoadingContainer>
      )}
    </Container>
  );
};

LotesTable.propTypes = {
  idLotes: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default LotesTable;
